import React from 'react';

const Testimonials = () => {
  const testimonialsList = [
    {
      text: "Thanks to WorkflowNL, we've increased our production efficiency by 27% and reduced our inventory costs by 18%. The implementation was quick and seamless.",
      author: "Jan Bakker",
      position: "Operations Manager, TechFab BV",
      initials: "JB"
    },
    {
      text: "The local compliance features have helped us tremendously in meeting Dutch and Belgian regulations. The support from the team is exceptional.",
      author: "Lieke Vermeer",
      position: "CFO, MetaalWerk Nederland",
      initials: "LV"
    },
    {
      text: "As a small manufacturing company, we never thought we could afford an ERP system. Skyline has proven that quality doesn't have to be expensive.",
      author: "Marc Janssen",
      position: "Director, PlasticPro Benelux",
      initials: "MJ"
    }
  ];

  return (
    <section className="testimonials" id="testimonials">
      <div className="container">
        <div className="section-title">
          <h2>What Our Clients Say</h2>
          <p>Discover how Skyline Digital Solutions has helped other manufacturing companies in the Benelux region.</p>
        </div>
        <div className="testimonial-grid">
          {testimonialsList.map((testimonial, index) => (
            <div className="testimonial-card" key={index}>
              <p className="testimonial-text">"{testimonial.text}"</p>
              <div className="testimonial-author">
                <div className="author-img">{testimonial.initials}</div>
                <div className="author-info">
                  <h4>{testimonial.author}</h4>
                  <p>{testimonial.position}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;